'use client';

import React from 'react';
import { useToast } from './toast-context';
import { Toast } from './toast';

type ToastContainerProps = {
  className?: string;
};

export const ToastContainer = ({ className }: ToastContainerProps) => {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className={`toast-container space-y-2 ${className || ''}`}>
      {toasts.map(toast => (
        <Toast key={toast.id} toast={toast} onClose={removeToast} />
      ))}
    </div>
  );
};
